import promptsJson from "./prompts.json";
import {
  AGE_GROUPS,
  PROMPT_TYPES,
  WEIRDNESS_LEVELS,
  type Prompt,
} from "./types";

export const PROMPTS: Prompt[] = promptsJson as Prompt[];

export * from "./types";
export * from "./selection";
export * from "./progress";
export * from "./storage";
export * from "./api";
export { DigClientApp } from "./client/ClientApp";
export type { DigClientAppProps, DigNotifications } from "./client/ClientApp";

export function validatePromptCatalog(prompts: readonly Prompt[] = PROMPTS): string[] {
  const errors: string[] = [];
  if (prompts.length !== 400) errors.push(`Expected 400 prompts, got ${prompts.length}`);

  const ids = new Set<string>();
  const texts = new Set<string>();
  for (const p of prompts) {
    if (ids.has(p.id)) errors.push(`Duplicate id: ${p.id}`);
    ids.add(p.id);
    if (texts.has(p.text)) errors.push(`Duplicate text: ${p.text.slice(0, 40)}…`);
    texts.add(p.text);
    if (!AGE_GROUPS.includes(p.ageGroup)) errors.push(`Invalid ageGroup: ${p.id}`);
    if (!PROMPT_TYPES.includes(p.type)) errors.push(`Invalid type: ${p.id}`);
    if (!WEIRDNESS_LEVELS.includes(p.weirdness)) errors.push(`Invalid weirdness: ${p.id}`);
    if (/\b(uw|u\b|kunt u|ziet u)\b/i.test(p.text)) {
      errors.push(`Formal u/uw in: ${p.id}`);
    }
  }

  for (const age of AGE_GROUPS) {
    const count = prompts.filter((p) => p.ageGroup === age).length;
    if (count < 120 || count > 140) {
      errors.push(`Age ${age} count ${count} outside 120-140`);
    }
  }

  const forbidden = /(mes|vuur|alcohol|drugs|sigaret|vreemdeling|auto|snelweg|spring van|steek)/i;
  for (const p of prompts) {
    if (forbidden.test(p.text)) errors.push(`Forbidden pattern in ${p.id}: ${p.text}`);
  }

  return errors;
}

export function runPromptCatalogSelfCheck(): void {
  const errors = validatePromptCatalog();
  if (errors.length > 0) {
    throw new Error(`Prompt catalog invalid:\n${errors.join("\n")}`);
  }
}

if (import.meta.env?.DEV) {
  runPromptCatalogSelfCheck();
}